const emojiOptions = [
  "😀",
  "😎",
  "🤓",
  "🧠",
  "🚀",
  "🌍",
  "🎯",
  "🏆",
  "🧭",
  "💡",
  "💩",
  "🤪",
  "👻",
  "🦄",
  "🐶",
  "🐱",
  "🦊",
  "🐼"
];

export default emojiOptions;
